import { Box } from '@mui/material'
import React from 'react'

const ChipList: React.FC = ({ children }) => {
  return (
    <Box
      data-test-chiplist
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      gap={1}
    >
      {children}
    </Box>
  )
}

export default ChipList
